import { useState } from 'react';

import { Box, Separator, Text, ToggleGroup } from '@betterment/samba-react';

import { PerformanceChartSection } from './components/balance-toggle-view/PerformanceChartSection';
import { ProjectionChartSection } from './components/projections-toggle-view/ProjectionChartSection';
import { useEnvelopeAccountProjections } from './hooks/useEnvelopeAccountProjections';

export const ManagedAccountOverview = () => {
  const [selectedTab, setSelectedTab] = useState('balance');
  const { data } = useEnvelopeAccountProjections();

  if (!data || (data.account.__typename === 'ManagedAccount' && !data.account.projection)) {
    return (
      <>
        <Separator />
        <PerformanceChartSection />
      </>
    );
  }

  return (
    <Box css={{ display: 'grid', gap: 'space.300', pt: 'space.100' }}>
      <ToggleGroup
        onValueChange={(value: string) => {
          if (value) setSelectedTab(value);
        }}
        spacing="compact"
        type="single"
        value={selectedTab}
      >
        <ToggleGroup.Item value="balance">
          <Text variant="text50">Balance</Text>
        </ToggleGroup.Item>
        <ToggleGroup.Item value="projection">
          <Text variant="text50">Projection</Text>
        </ToggleGroup.Item>
      </ToggleGroup>
      {selectedTab === 'balance' ? <PerformanceChartSection /> : <ProjectionChartSection />}
    </Box>
  );
};
